var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5078 18.7109C29.5078 22.0703 28.9141 25.0156 27.7266 27.5469C26.5391 30.0781 24.8359 32.0312 22.6172 33.4062C20.4141 34.7812 17.8828 35.4688 15.0234 35.4688C12.1953 35.4688 9.67188 34.7891 7.45312 33.4297C5.23438 32.0703 3.51562 30.1328 2.29688 27.6172C1.07812 25.0859 0.460939 22.1797 0.445312 18.8984V17.2109C0.445312 13.8516 1.04688 10.8984 2.25 8.35156C3.46875 5.78906 5.17969 3.82812 7.38281 2.46875C9.60156 1.09375 12.1328 0.40625 14.9766 0.40625C17.8203 0.40625 20.3438 1.09375 22.5469 2.46875C24.7656 3.82812 26.4766 5.78906 27.6797 8.35156C28.8984 10.8984 29.5078 13.8438 29.5078 17.1875V18.7109ZM22.3828 17.1641C22.3828 13.5859 21.7422 10.8672 20.4609 9.00781C19.1797 7.14844 17.3516 6.21875 14.9766 6.21875C12.6172 6.21875 10.7969 7.14062 9.51562 8.98438C8.23438 10.8125 7.58594 13.5 7.57031 17.0469V18.7109C7.57031 22.1953 8.21094 24.8984 9.49219 26.8203C10.7734 28.7422 12.6172 29.7031 15.0234 29.7031C17.3828 29.7031 19.1953 28.7812 20.4609 26.9375C21.7266 25.0781 22.3672 22.375 22.3828 18.8281V17.1641Z",
    fill: "url(#paint0_linear_6_90)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_90",
    x1: 14.9766,
    y1: 0.40625,
    x2: 14.9766,
    y2: 35.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/O.ccb7dc1fc2ade871e4006d0dbe76567d.svg";
export { ForwardRef as ReactComponent };